import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdateScrapFinanceTradesAdditionsRequestModel, UpdateScrapFinanceTradesAdditionsResponseModel } from "@/features/accounts/scrap-finance/services/update-trades-additions-model";

export class UpdateScrapFinanceTradesAdditionsApi {
  /**
   * 銀行明細メモ・無効明細更新API
   */
  public updateScrapFinanceTradesAdditions = async (
    param: UpdateScrapFinanceTradesAdditionsRequestModel
  ): Promise<UpdateScrapFinanceTradesAdditionsResponseModel> => {
    const path = `/api/scrapingaccounts/finances/tradesadditions`;
    const res = await ApiClient.instance.put<UpdateScrapFinanceTradesAdditionsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
